export const ReservationTypeForSearchReservationRequestList = {
	/**
	 * 直近3ヶ月の新着リクエスト
	 */
	monthCount: "monthCount",
	/**
	 * チェックイン日
	 */
	cInDate: "cInDate",
	/**
	 * リクエスト日/更新日
	 */
	updatedDate: "updatedDate",
} as const;

export type ReservationTypeForSearchReservationRequestList =
	(typeof ReservationTypeForSearchReservationRequestList)[keyof typeof ReservationTypeForSearchReservationRequestList];
